import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "gtmChildren", "id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { renderChildren } from '../helpers';
const ClickWrapper = _ref => {
  let {
      children,
      gtmChildren,
      id
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [clickState, setClickState] = useState(false);
  const renderedChildren = clickState ? renderChildren(gtmChildren, {
    clickState,
    clickId: id,
    componentProps: _objectSpread({}, props)
  }) : null;
  return /*#__PURE__*/React.createElement("div", {
    role: "button",
    onClick: () => {
      setClickState(true);
    }
  }, renderedChildren, children);
};
ClickWrapper.propTypes = {
  id: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  gtmChildren: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
ClickWrapper.defaultProps = {
  id: null,
  children: [],
  gtmChildren: []
};
export default ClickWrapper;
//# sourceMappingURL=ClickWrapper.js.map